export default __webpack_public_path__ + "static/media/hudl.30e85685.svg";